import { useTranslation } from '../../../i18n/TranslationContext';

const steps = [
  { number: '01', titleKey: 'brands.process.step1', descKey: 'brands.process.step1_desc' },
  { number: '02', titleKey: 'brands.process.step2', descKey: 'brands.process.step2_desc' },
  { number: '03', titleKey: 'brands.process.step3', descKey: 'brands.process.step3_desc' },
  { number: '04', titleKey: 'brands.process.step4', descKey: 'brands.process.step4_desc' },
];

export default function BrandProcess() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-20 text-center">
          <p className="text-xs font-medium uppercase tracking-widest text-primary-500 mb-4">
            Process
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight">
            {t('brands.process.title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step, i) => (
            <div key={i} className="relative bg-background-50 rounded-2xl border border-foreground-100/60 p-8 md:p-10 flex flex-col">
              <span className="text-4xl font-heading text-primary-400 mb-4">
                {step.number}
              </span>
              <h3 className="text-base font-bold text-foreground-950 mb-2.5">
                {t(step.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(step.descKey)}
              </p>
              {i < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-primary-300/40"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}